export enum LayoutMode {
    VIEW = 'VIEW',
    VIEW_AUTH_MGMT = 'VIEW_AUTH_MGMT',
    EDIT = 'EDIT',
    STANDALONE = 'STANDALONE',
  }